import { ActionIcon, Alert, Checkbox, Group, LoadingOverlay, Select, Stack } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDebouncedValue } from "@mantine/hooks";
import { SectionBox } from "components/v2/SectionBox";
import { TeleportSelectCard } from "components/v2/Teleport/TeleportSelectCard";
import React, { forwardRef, useEffect } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import BackendServiceV2 from "services/v2/BackendService";
import { ArrowRight, Building, Check, Link, X } from "tabler-icons-react";
import equal from'fast-deep-equal';
import { showNotification } from "@mantine/notifications";
import { IconAlertCircle } from "@tabler/icons-react";

export function DevelopmentPortal({development}) {

    const queryClient = useQueryClient();

    const form = useForm({
        initialValues: {
            idMainTeleport: development.idMainTeleport || '',
            publicInPortal: development.publicInPortal || '',
        }
    });

    const [debouncedFormValues] = useDebouncedValue(form.values, 3000);

    useEffect(() => {
        form.validate();

        if(!form.isValid()) return;

        if(!equal(
            {
                idMainTeleport: development?.idMainTeleport || '',
                publicInPortal: development?.publicInPortal || ''
            }, 
            debouncedFormValues
        )) {
            updateDevelopment(debouncedFormValues);
        }
    // eslint-disable-next-line
    }, [debouncedFormValues])

    const {mutate: updateDevelopment, isLoadingUpdate} = useMutation((data) => {
        return BackendServiceV2.put(`/development/${development?.idDevelopment}`, data);
    }, {
        onSuccess: () => {
            queryClient.invalidateQueries('development-data');
            showNotification({
                title: 'Empreendimento atualizada com sucesso',
                message: '',
                icon: <Check />,
                color: 'green',
                autoClose: 5000,
            });
        },
        onError: (error) => {
            showNotification({
                title: 'Um erro ocorreu',
                message: error?.response?.data?.message,
                icon: <X />,
                color: 'red',
                autoClose: 5000,
            });
        }
    });

    const {data: teleports, isLoading} = useQuery(['teleport-list-data', development.idDevelopment], () => {        
        return BackendServiceV2.get(`/development/${development.idDevelopment}/teleport?page=0&size=100`);
    });

    const SelectItem = forwardRef(
        ({ label, description, value, ...others }, ref) => (
            <TeleportSelectCard value={value} label={label} description={description} others={others} reference={ref} />
        )
    );

    return (
        <SectionBox
            title="Publicação"
        >
            <LoadingOverlay visible={isLoading || isLoadingUpdate} />

            <form>
                <Stack>
                    <Group noWrap spacing={3}>
                        <Select
                            required
                            label="Teleport Principal"
                            description="Teleport com Espelho de vendas ativo"
                            placeholder=""
                            size="md"
                            itemComponent={SelectItem}
                            data={teleports?.result?.map(teleport => {
                                return {
                                    label: teleport?.metadata?.title, 
                                    description: teleport?.metadata?.subtitle, 
                                    value: teleport?.id
                                }
                            }) || []}
                            searchable
                            nothingFound="Nenhum Teleport encontrado"
                            {...form.getInputProps('idMainTeleport')}
                            icon={<Building />}
                        />

                        <ActionIcon mt="auto" h="2.625rem" component="a" href={'/teleport/' + development.idMainTeleport} target="_blank" title="Abrir" color="#ff5e00"><ArrowRight /></ActionIcon>
                    </Group>

                    <Checkbox
                        label="Público"
                        description="Empreendimento ficará visível no portal de vendas"
                        name="publicInPortal"
                        size="md"
                        checked={form.getInputProps('publicInPortal').value}
                        {...form.getInputProps('publicInPortal')}
                    />
                    
                    {!development.address &&
                        <Alert icon={<IconAlertCircle size="1rem" />} title="Empreendimento sem endereço!" color="red">
                            Empreedimento sem endereço não aparecem no Portal!
                        </Alert>
                    }
                </Stack>
            </form>
        </SectionBox>
    )
}